const initialState = { meet: [] };
export const meetReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case "ADD_MEET":
      return { ...state, meet: payload };
    default:
      return state;
  }
};
